export default function ($rootScope, $translate) {
    const loadEnums = () => {
        return {
            TRANSLATIONS: {
                firstName: $translate.instant('template.firstName'),
                lastName: $translate.instant('template.lastName'),
                clientEmail: $translate.instant('template.clientEmail'),
                listOfTrainings: $translate.instant('template.listOfTrainings'),
                listOfTrainingsWTimeZones: $translate.instant('template.listOfTrainingsWTimeZones'),
                courseName: $translate.instant('template.courseName'),
                trainingName: $translate.instant('template.trainingName'),
                trainingTimeStart: $translate.instant('template.trainingTimeStart'),
                courseRoom: $translate.instant('template.courseRoom'),
                trainingTimeEnd: $translate.instant('template.trainingTimeEnd'),
                trainingType: $translate.instant('template.trainingType'),
                evaluable: $translate.instant('template.evaluable'),
                evaluator: $translate.instant('template.evaluator'),
                deadline: $translate.instant('template.deadline'),
                evaluationUrl: $translate.instant('template.evaluationUrl'),
                reportUrl: $translate.instant('template.reportUrl'),
                groupName: $translate.instant('template.groupName'),
                surveyUrl: $translate.instant('template.surveyUrl'),
                userDisplayName: $translate.instant('template.userDisplayName'),
                managerDisplayName: $translate.instant('template.managerDisplayName'),
                reviewDate: $translate.instant('template.reviewDate'),
                performanceReviewUrl: $translate.instant('template.performanceReviewUrl'),
                declineReason: $translate.instant('template.declineReason'),
                expireTime: $translate.instant('template.expireTime'),
                trainingDeadline: $translate.instant('template.trainingDeadline'),
                employeeUrl: $translate.instant('template.employeeUrl'),
                licenceName: $translate.instant('template.licenceName'),
                closestPeriodEndDate: $translate.instant('template.closestPeriodEndDate'),
                closestPeriodAcquiringDate: $translate.instant('template.closestPeriodAcquiringDate'),
                pointsPerPeriod: $translate.instant('template.pointsPerPeriod'),
                reviewRoom: $translate.instant('template.reviewRoom'),
                timeZone: $translate.instant('template.timeZone'),
                applicationDate: $translate.instant('template.applicationDate'),
                courseRoomLocation: $translate.instant('template.Pärnu mnt 141, Tallinn'),
                courseRoomLocationDetails: $translate.instant('template.Second floor, use stairs'),
                externalCourseName: $translate.instant('template.External pizza workshop'),
                tasklistName: $translate.instant('template.Learning process'),
                marketplaceInvoiceUrl: $translate.instant('template.marketplaceInvoiceUrl'),
                listOfAssessments: $translate.instant('template.listOfAssessments'),
                employeeName: $translate.instant('template.employeeName'),
                directManagerName: $translate.instant('template.directManagerName'),
                userSite: $translate.instant('template.userSite')
            }
        };
    };

    const enums = loadEnums();

    $rootScope.$on('$translateChangeSuccess', () => {
        enums.TRANSLATIONS = loadEnums().TRANSLATIONS;
    });

    return enums;
}



// WEBPACK FOOTER //
// ./src/app/enums/notification/template/index.js